import { type ISocketOrderEvent } from '@/types/ISocketOrderEvent';
import { type IOrderNotification } from '@/types/INotification';

/**
 * Строит стабильный идентификатор уведомления о заказе. Завязан на `id`
 * заказа и `datetime` события, чтобы повторная доставка того же события
 * давала тот же id (дедуп в очереди и истории).
 *
 * @param event - событие заказа из Mercure
 * @returns идентификатор уведомления
 */
export const buildOrderNotificationId = (event: ISocketOrderEvent): string =>
  `order-${event.data.id}-${event.datetime}`;

/**
 * Создаёт уведомление о заказе из события Mercure. Новое уведомление
 * непрочитано, метка времени — момент создания.
 *
 * @param event - событие заказа из Mercure
 * @returns уведомление типа `order`
 */
export const createOrderNotification = (
  event: ISocketOrderEvent
): IOrderNotification => ({
  id: buildOrderNotificationId(event),
  type: 'order',
  createdAt: Date.now(),
  isRead: false,
  payload: event
});
